import { IPromotion } from '../../types/builder/promotions';
import { IApplicationState } from '../../types/redux';

export const selectPromotions = (state: IApplicationState): IPromotion[] => {
  return state.builderCard.promotions;
};
